/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} CnameInputs */

const en_cname = /** @type {(inputs: CnameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CNAME:`)
};

const es_cname = /** @type {(inputs: CnameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CNAME:`)
};

const fr_cname = /** @type {(inputs: CnameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CNAME :`)
};

const de_cname = /** @type {(inputs: CnameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CNAME:`)
};

const ja_cname = /** @type {(inputs: CnameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CNAME:`)
};

const zh_cname = /** @type {(inputs: CnameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CNAME 记录：`)
};

const ar_cname = /** @type {(inputs: CnameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سجل CNAME:`)
};

const id_cname = /** @type {(inputs: CnameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CNAME:`)
};

const it_cname = /** @type {(inputs: CnameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CNAME:`)
};

const ru_cname = /** @type {(inputs: CnameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CNAME:`)
};

const pt_cname = /** @type {(inputs: CnameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CNAME:`)
};

const ko_cname = /** @type {(inputs: CnameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CNAME:`)
};

/**
* | output |
* | --- |
* | "CNAME:" |
*
* @param {CnameInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const cname = /** @type {((inputs?: CnameInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<CnameInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cname(inputs)
	if (locale === "es") return es_cname(inputs)
	if (locale === "fr") return fr_cname(inputs)
	if (locale === "de") return de_cname(inputs)
	if (locale === "ja") return ja_cname(inputs)
	if (locale === "zh") return zh_cname(inputs)
	if (locale === "ar") return ar_cname(inputs)
	if (locale === "id") return id_cname(inputs)
	if (locale === "it") return it_cname(inputs)
	if (locale === "ru") return ru_cname(inputs)
	if (locale === "pt") return pt_cname(inputs)
	return ko_cname(inputs)
});